import { isString } from 'lodash/fp';

function checkString(string: string, name: string) {
    if (!isString(string)) {
        throw new TypeError(`Expected ${name} to be string, got: (${String(string)}).`);
    }
}

export const parsePaymentCardExpirationDate = (expirationString: string) => {
    checkString(expirationString, 'expirationString');

    const [monthString, yearString = ''] = expirationString.replace(/[^0-9/]/g, '').split('/');
    const yearNumber = parseInt(yearString, 10);

    return {
        year: yearNumber + (yearNumber < 100 ? 2000 : 0),
        month: parseInt(monthString, 10),
    };
};
